import { render, staticRenderFns } from "./URL.vue?vue&type=template&id=9738be74&functional=true&"
import script from "./URL.vue?vue&type=script&lang=ts&"
export * from "./URL.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports